const parsePayload = value => {
  if (value === null || value === undefined) return null;
  if (typeof value !== 'string') return value;
  try {
    return JSON.parse(value);
  } catch (_error) {
    return value;
  }
};

const isRecord = value => (
  value !== null
  && typeof value === 'object'
  && !Array.isArray(value)
);

const flatten = (value, prefix = '', result = {}) => {
  if (!isRecord(value)) {
    result[prefix || 'value'] = value;
    return result;
  }
  const entries = Object.entries(value);
  if (!entries.length && prefix) result[prefix] = value;
  entries.forEach(([key, child]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (isRecord(child) && Object.keys(child).length) flatten(child, path, result);
    else result[path] = child;
  });
  return result;
};

const valuesMatch = (left, right) => JSON.stringify(left) === JSON.stringify(right);

export const buildAuditChanges = (before, after) => {
  const beforePayload = parsePayload(before);
  const afterPayload = parsePayload(after);
  const beforeFields = beforePayload === null ? {} : flatten(beforePayload);
  const afterFields = afterPayload === null ? {} : flatten(afterPayload);
  return [...new Set([...Object.keys(beforeFields), ...Object.keys(afterFields)])]
    .sort((left, right) => left.localeCompare(right))
    .filter(field => !valuesMatch(beforeFields[field], afterFields[field]))
    .map(field => ({ field, before: beforeFields[field], after: afterFields[field] }));
};

export const formatAuditValue = value => {
  if (value === undefined) return 'Not set';
  if (value === null) return 'Null';
  if (typeof value === 'object') return JSON.stringify(value, null, 2);
  return String(value);
};
